import { h } from "preact";
import { Switch, Button, Tooltip, Typography } from 'antd';

const { Text } = Typography;

const SettingItem = ({
                         title,
                         description,
                         settingKey,
                         apiMethods,
                         children,
                         settings,
                         loading,
                         onToggle,
                         disabled = false,
                         globallyDisabled = false,
                         isMaster = false,
                         invertLogic = false
                     }) => {
    // Handle null values (tri-state: null, true, false)
    const rawValue = settings[settingKey];
    const isNull = rawValue === null;

    // For inverted logic (like turn_off_fpe), we need to flip the switch display
    // For null values, treat as false/off
    const displayValue = isNull ? false : (invertLogic ? !rawValue : rawValue);

    const getTooltipText = () => {
        if (globallyDisabled) return "This setting is disabled globally and cannot be enabled for individual consumers";
        if (disabled) return "This setting is controlled by the FPE Master Switch";
        if (isNull) return "This setting is not configured (null). Toggle to set a value.";
        if (invertLogic) return "Note: This switch controls the backend 'turn_off_fpe' parameter (inverted logic)";
        return "Click for more information";
    };

    return (
        <div style={{ padding: '16px 0', borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1, marginRight: '16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <Text strong style={{ color: disabled ? '#999' : 'inherit' }}>
                            {title}
                            {isMaster && (
                                <span style={{
                                    fontSize: '12px',
                                    color: '#1890ff',
                                    fontWeight: 'normal',
                                    marginLeft: '8px'
                                }}>
                                    (Master Switch)
                                </span>
                            )}
                            {isNull && (
                                <span style={{
                                    fontSize: '12px',
                                    color: '#ff7a00',
                                    fontWeight: 'normal',
                                    marginLeft: '8px'
                                }}>
                                    (Not Configured)
                                </span>
                            )}
                        </Text>
                        <Tooltip title={getTooltipText()}>
                            <Button
                                type="link"
                                size="small"
                                style={{
                                    padding: 0,
                                    minWidth: 'auto',
                                    height: 'auto',
                                    lineHeight: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: disabled ? '#999' : 'inherit',
                                    marginBottom: "8px",
                                }}
                            >
                                {disabled ? '⚠️' : (isNull ? '❓' : (invertLogic ? '🔄' : 'ℹ️'))}
                            </Button>
                        </Tooltip>
                    </div>
                    <Text type="secondary" style={{
                        fontSize: '14px',
                        display: 'block',
                        marginBottom: '12px',
                        color: disabled ? '#ccc' : 'inherit'
                    }}>
                        {description}
                        {invertLogic && (
                            <div style={{
                                marginTop: '8px',
                                fontSize: '12px',
                                color: '#1890ff',
                                fontStyle: 'italic'
                            }}>
                                💡 Switch ON = Backend parameter "turn_off_fpe" = false (FPE enabled)<br/>
                                💡 Switch OFF = Backend parameter "turn_off_fpe" = true (FPE disabled)
                            </div>
                        )}
                        {isNull && (
                            <div style={{
                                marginTop: '8px',
                                fontSize: '12px',
                                color: '#ff7a00',
                                fontStyle: 'italic'
                            }}>
                                ⚠️ Current value: null (not configured)
                            </div>
                        )}
                    </Text>
                    {children}
                </div>
                <Switch
                    checked={displayValue}
                    onChange={() => onToggle(settingKey, apiMethods)}
                    loading={loading[settingKey]}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

export default SettingItem;